import React from "react";

import CasinoKPIsV2 from "./CasinoKPIsV2";

interface CasinoKPIsProps {
  currencySymbol?: string;
}

const CasinoKPIs: React.FC<CasinoKPIsProps> = ({ currencySymbol }) => {
  return <CasinoKPIsV2 currencySymbol={currencySymbol} />;
};

export default CasinoKPIs;
